// extracted by mini-css-extract-plugin
module.exports = {"resultsPage":"ResultsPage_resultsPage__1a4zR","margin":"ResultsPage_margin__XtREg"};